<template>
  <div class="zadi-session-volunteers">
    <ag-table :data-source-api="getAssignedVolunteers" :grid-options="gridOptions" :permissions="{}" :rtl="false"
      :is-entities-response="false" />
  </div>
</template>

<script>
import { RepositoryFactory } from "../../volunteer-repositories/volunteerRepositoryFactory";
import AgTable from "@/app/shared/shared-components/ag-grid/AgTableServerSide";

const zadiSessionsRepo = RepositoryFactory.get("zadiSessionsRepository");

export default {
  name: "ZadiSessionVolunteers",
  components: {
    AgTable,
  },
  data() {
    return {
      gridApi: null,
      gridOptions: null,
      genders: ["ذكر", "انثى"],
    };
  },
  methods: {
    createColDefs() {
      let self = this;
      return [
        {
          headerName: "معرف المتطوع",
          field: "id",
          sortable: true,
          width: 200,
        },
        {
          headerName: "الاسم",
          field: "name",
          filter: "agTextColumnFilter",
          width: 210,
          sortable: false,
        },
        {
          headerName: "كود اليسير",
          field: "uniqueIdentifier",
          filter: "agTextColumnFilter",
          width: 200,
          sortable: false,
        },
        {
          headerName: "رقم البطاقة",
          field: "cardNumber",
          filter: "agTextColumnFilter",
          width: 200,
          sortable: false,
        },
        {
          headerName: "رقم الموبايل",
          field: "phoneNumber",
          filter: "agTextColumnFilter",
          width: 210,
          sortable: false,
        },
        {
          headerName: "المجموعة",
          field: "volunteerInfo.groupName",
          filter: "agTextColumnFilter",
          width: 210,
          sortable: false,
        },
        {
          headerName: "الفرع الجامعي",
          field: "volunteerInfo.collage",
          filter: "agTextColumnFilter",
          width: 210,
          sortable: false,
        },
        {
          headerName: "الجنس",
          field: "volunteerInfo.gender",
          filter: "agSetColumnFilter",
          filterParams: { values: self.genders },
          width: 210,
          sortable: false,
        },
        {
          headerName: "الصف",
          field: "volunteerInfo.studyYear",
          filter: "agTextColumnFilter",
          width: 210,
          sortable: false,
        },
      ];
    },
    async getAssignedVolunteers(query) {
      const response = await zadiSessionsRepo.fetchZadiSessionAudience(
        this.$route.params.id,
        `${query}&scope=assigned`
      );
      return response.volunteers || { data: [], total: 0 };
    },
  },
  created() {
    this.gridOptions = {};
    this.gridOptions.columnDefs = this.createColDefs();
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
  },
};
</script>
